module.exports = "<app-topbar [topbartext]=\"topbartext\"></app-topbar>\n"